var chunkMapping = {
	"166": [
		9166
	],
	"343": [
		7343
	],
	"636": [
		5271,
		330
	],
	"697": [
		1697
	],
	"711": [
		5711
	],
	"921": [
		6921
	]
};
var idToExternalAndNameMapping = {
	"330": [
		"default",
		"./generic/components/general/toast",
		1005
	],
	"1697": [
		"default",
		"./generic/elements/form",
		1005
	],
	"5271": [
		"default",
		"./generic/elements/icons",
		1005
	],
	"5711": [
		"default",
		"./generic/elements/info-block",
		1005
	],
	"6921": [
		"default",
		"./generic/elements/loading",
		1005
	],
	"7343": [
		"default",
		"./generic/elements/button",
		1005
	],
	"9166": [
		"default",
		"./generic/elements/divider",
		1005
	]
};
var idToRemoteMap = {
	"330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1697": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6921": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7343": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9166": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"1697": {
		"shareScope": "default",
		"name": "./generic/elements/form",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"6921": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"7343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"9166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 1005,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}